import { identity, map, merge, Subject, Subscription } from 'rxjs';
import { createStore } from './store';
const GLOBAL_EFFECT_UNHANDLED_ERROR_SUBJECT = new Subject();
export const GLOBAL_EFFECT_UNHANDLED_ERROR$ = GLOBAL_EFFECT_UNHANDLED_ERROR_SUBJECT.asObservable();
function emitGlobalUnhandledError(effectError) {
    if (GLOBAL_EFFECT_UNHANDLED_ERROR_SUBJECT.observed) {
        GLOBAL_EFFECT_UNHANDLED_ERROR_SUBJECT.next(effectError);
    }
    else {
        console.error('Uncaught error in Effect', effectError);
    }
}
const increaseCount = (count) => count + 1;
const decreaseCount = (count) => (count > 0 ? count - 1 : 0);
export function createEffectController() {
    const subscriptions = new Subscription();
    const event$ = new Subject();
    const done$ = new Subject();
    const error$ = new Subject();
    const pendingCount = createStore(0, {
        internal: true,
    });
    subscriptions.add(() => {
        event$.complete();
        done$.complete();
        error$.complete();
        pendingCount.destroy();
    });
    const notifications$ = merge(done$.pipe(map((entry) => ({ type: 'result', ...entry }))), error$.pipe(map((entry) => ({ type: 'error', ...entry }))));
    return {
        state: {
            done$: done$.asObservable(),
            result$: done$.pipe(map(({ result }) => result)),
            error$: error$.asObservable(),
            final$: notifications$,
            pending: pendingCount.query((count) => count > 0),
            pendingCount: pendingCount.query(identity),
        },
        start: () => pendingCount.update(increaseCount),
        next: (result) => done$.next(result),
        complete: () => pendingCount.update(decreaseCount),
        error: (effectError) => {
            if (effectError.origin === 'handler') {
                pendingCount.update(decreaseCount);
            }
            if (error$.observed) {
                error$.next(effectError);
            }
            else {
                emitGlobalUnhandledError(effectError);
            }
        },
        destroy: () => {
            subscriptions.unsubscribe();
        },
    };
}
//# sourceMappingURL=effectController.js.map